module.exports = "<button title=\"Download Invoice\" class=\"btn-block btn-default buy-btn-cart download-inv\" style=\"width:unset; float: right;\" [disabled]=\"isclickbuttonRegisterprofile[invoiceId]\" (click)=\"getSingleInvoiceDetail(invoiceId);\"><i class=\"fa fa-cloud-download \"></i>  <span>Download Invoice</span> <i class=\"fa fa-refresh fa-spin loderspace\" *ngIf=\"isclickbuttonRegisterprofile[invoiceId]\"></i></button>\n"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/package-inv-download/package-inv-download.component.html
// module id = ../../../../../src/app/home/package-inv-download/package-inv-download.component.html
// module chunks = common